<template>
  <DpplSkeletonLoader class="horizontal-bar-skeleton">
    <div class="skeleton-body">
      <div
        v-for="(barWidth, index) in barsWidths"
        :key="index"
        class="chart-bars"
      >
        <v-skeleton-loader
          type="text"
          width="48px"
          height="17px"
        />
        <div
          :style="{ width: `${barWidth}px` }"
          class="bar"
        />
      </div>
    </div>
  </DpplSkeletonLoader>
</template>

<script>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'HorizontalBarChartWidgetSkeleton',
  components: {
    DpplSkeletonLoader,
  },
  data() {
    return {
      barsWidths: [145, 145, 108, 133, 214, 173, 108],
    };
  },
};
</script>

<style lang="less" scoped>
.horizontal-bar-skeleton {
  height: 100%;
  width: 100%;
}

.skeleton-body {
  height: calc(100% - 17px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 24px;
}

.chart-bars {
  display: flex;
  align-items: center;
}

.bar {
  background-color: @grey-400;
  height: 24px;
  margin-left: 11px;
}

:deep(.v-skeleton-loader__bone) {
  margin: 0 !important;
}
</style>
